import { render } from "./AreaConcentracao.vue?vue&type=template&id=3c24f932"
import script from "./AreaConcentracao.vue?vue&type=script&lang=js"
export * from "./AreaConcentracao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__